import { Component, Input } from '@angular/core';
import { Patient } from '../../models/patient';
import { Intervention } from '../../models/intervention';
import { TuiCardLarge } from '@taiga-ui/layout';
import { TuiSurface } from '@taiga-ui/core';
import { InterventionListTimelineComponent } from '../intervention-list-timeline/intervention-list-timeline.component';
import { InterventionListComponent } from '../intervention-list/intervention-list.component';

@Component({
  selector: 'app-intervention-list-card',
  standalone: true,
  imports: [
    TuiCardLarge,
    TuiSurface,
    InterventionListTimelineComponent,
    InterventionListComponent,
  ],
  templateUrl: './intervention-list-card.component.html',
  styleUrl: './intervention-list-card.component.scss'
})
export class InterventionListCardComponent {
  @Input() patient?: Patient;
  @Input() activite?: string;

  interventionListFiltree(): Intervention[] | undefined {
    if (this.patient?.interventionList?.data) {
      return this.patient.interventionList.data.filter(intervention => {
        return intervention.dateDeRealisation !== undefined;
      });
    }

    return undefined;
  }

}